import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { constants } from "../../../constants";
import { ContactModel } from "../models/contact.model";

@Injectable({
    providedIn: 'root'
})
export class ContactService {
    constructor(private http: HttpClient) {
    }

    public sendContactEmail(contactModel: ContactModel) {
        return this.http.post(constants.uriParts.contact, contactModel);
    }
}